import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Alert, IconButton } from '@mui/material'
import InformationTable from '../../../components/Table/InformationTable'
import TableHeader from '../../../components/TableHeader/TableHeader'
import PageLoading from '../../../components/PageLoading/PageLoading'
import FechaSelector from '../../../components/form/FechaSelector/FechaSelector'
import { dateToDateTime, dateToString, getToday } from '../../../utils/date'
import { textFilter } from '../../../utils/table'
import { getPruebas } from '../../../utils/api/leads'
import { downloadCSVFile, getCSVContent } from '../../../utils/csv'
import { getAuth } from '../../../utils/auth'
import { useNotification } from '../../../context/NotificationManager/NotificationManager'
import { capitalize } from '../../../utils/string'
import { getSituacion } from '../../../utils/model/leads'
import css from './Pruebas.module.css'

const Pruebas = () => {
  const [fecha, setFecha] = useState(getToday())
  const [search, setSearch] = useState('')

  const notification = useNotification()
  const userData = getAuth()

  const { isLoading, data: pruebaList = [] } = useQuery({
    queryKey: ['marketing', 'feedback', 'list', fecha, userData.centro],
    queryFn: () =>
      getPruebas({ fecha: dateToString(fecha), centro: userData.centro }).catch(
        err => {
          notification.error({
            title: 'Error al recuperar las pruebas',
            content: err
          })
          return []
        }
      ),
    enabled: !!fecha
  })

  const handleExport = () => {
    const content = getCSVContent({
      columns: [
        'Contacto',
        'Relación',
        'Alumno',
        'Centro',
        'Nº Contactos',
        'Estado',
        'Teléfono'
      ],
      data: pruebaList,
      transform: p => [
        p.contacto,
        p.relacion,
        p.alumno,
        p.centro,
        p.contactos,
        p.estado,
        p.telefonos?.[0]?.telefono || '--'
      ]
    })
    downloadCSVFile(content, `seguimiento-pruebas-${dateToString(fecha)}`)
  }

  const filterSearch = prueba => {
    return textFilter({
      object: prueba,
      fields: ['contacto', 'estado'],
      search: search
    })
  }
  const totalLeadsCaptados = pruebaList.filter(
    lead => getSituacion(lead.estado) === 'Captado'
  ).length
  const totalLeadsPerdidos = pruebaList.filter(
    lead => getSituacion(lead.estado) === 'Perdido'
  ).length
  const totalLeadsAbiertos = pruebaList.filter(
    lead => getSituacion(lead.estado) === 'Abierto'
  ).length

  return (
    <PageLoading isLoading={isLoading}>
      <TableHeader
        actions={
          <div className={css.actions}>
            <IconButton
              className={css.download}
              size='small'
              color='primary'
              onClick={() => fecha && handleExport()}
            >
              <i className='material-icons'>download</i>
            </IconButton>
            <FechaSelector
              className={css.fecha}
              label='Fecha'
              value={dateToDateTime(fecha)}
              onChange={setFecha}
            />
          </div>
        }
        title='Seguimiento pruebas'
        search={search}
        onSearchChange={e => setSearch(e.target.value)}
      />
      <Alert className={css.banner} severity='info'>
        Hay un total de {pruebaList.length} pruebas ({totalLeadsCaptados}{' '}
        convertidas | {totalLeadsPerdidos} perdidas | {totalLeadsAbiertos}{' '}
        abiertas)
      </Alert>
      <InformationTable
        isLoading={isLoading}
        details={[
          { title: 'Lead', key: 'contacto', sortDisabled: true },
          { title: 'Estado', key: 'estado' },
          { title: 'Teléfono', key: 'telefono' }
        ]}
        data={pruebaList.filter(filterSearch).map(prueba => ({
          contacto: (
            <Link className={css.link} to={`/leads/${prueba.id}/ficha`}>
              {prueba.contacto}
              {prueba.relacion && ` (${prueba.relacion})`}
            </Link>
          ),
          estado: capitalize(prueba.estado.replaceAll('_', ' ')),
          telefono: prueba.telefonos?.[0]?.telefono || '--'
        }))}
      />
    </PageLoading>
  )
}

export default Pruebas
